module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_3016.87628dd0.png";